const initialState = {
  filialId: 0,
  data: {},
  userId: '',
  modalState: {
    visible: false,
    data: {},
  },
  contractId: [],
  titleModal: '',
  dataPlans: {},
  userDataUpdate: {},
  dataPlansFunctions: [],
  userModal: {
    visible: false,
    data: {},
  },
  dataUserCompany: [],
  dataFilial: [],
  clientFilial: {
    seleted: {},
    filial: false,
  },
  invite: [],
  selectedRows: [],
  companySelected: [],
  // Varios grupos inteiros selecionados no header - ver utils/selecaoGrupos.js.
  gruposSelecionados: [],
  questionsFilial: {},
  companyPlan: {},
  adminTargetUser: null,
};

export const userData = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_DATA':
      return {
        ...state,
        data: action.data,
      };
    case 'GET_USER_ID':
      return {
        ...state,
        userId: action.userId,
      };
    case 'MODAL_TRUE':
      return {
        ...state,
        modalState: action.modalState,
      };
    case 'USER_MODAL':
      return {
        ...state,
        userModal: {...action.userModal},
      };
    case 'USER_DATA_UPDATE':
      return {
        ...state,
        userDataUpdate: action.userDataUpdate,
      };
    case 'CONTRACT_ID':
      return {
        ...state,
        contractId: action.contractId,
      };
    case 'TITLE_MODAL':
      return {
        ...state,
        titleModal: action.titleModal,
      };
    case 'DATA_PLANS':
      return {
        ...state,
        dataPlans: action.dataPlans,
      };
    case 'DATA_PLANS_FUNCTIONS':
      return {
        ...state,
        dataPlansFunctions: action.dataPlansFunctions,
      };
    case 'DATA_USER_COMPANY':
      return {
        ...state,
        dataUserCompany: action.dataUserCompany,
      };
    case 'DATA_FILIAL':
      return {
        ...state,
        dataFilial: [...action.dataFilial],
      };
    case 'CLIENT_FILIAL':
      return {
        ...state,
        clientFilial: action.clientFilial,
      };
    case 'SET_INVITATION':
      return {
        ...state,
        invite: action.invite,
      };
    case 'GET_FILIAL_ID':
      return {
        ...state,
        filialId: action.filialId,
      };
    case 'SET_CHECKETED_ROW':
      return {
        ...state,
        rowSelected: action.rowSelected,
      };
    case 'COMPANY_SELECTED':
      return {
        ...state,
        companySelected: action.companySelected,
        // Zerar o grupo selecionado zera tambem a soma de grupos (revisao de
        // 2026-09-29). Os logouts sem recarregar a pagina (Sidebar, Register,
        // Header), o login (postLoginNavigation), o arquivamento do grupo
        // selecionado (SettingsBlue) e a falha da Home despacham
        // setCompanySelected([]) - sem isto, gruposSelecionados sobrevivia a
        // todos eles e o proximo login no mesmo navegador herdava a soma de
        // grupos da conta anterior.
        ...(Array.isArray(action.companySelected) && action.companySelected.length === 0
          ? { gruposSelecionados: [] }
          : {}),
      };
    case 'GRUPOS_SELECIONADOS':
      return {
        ...state,
        gruposSelecionados: action.gruposSelecionados,
      };
    case 'SET_QUESTIONS_FILIAL':
      return {
        ...state,
        questionsFilial: action.questionsFilial,
      };
    case 'COMPANY_PLAN':
      return {
        ...state,
        companyPlan: action.companyPlan,
      };
    case 'ADMIN_TARGET_USER':
      return {
        ...state,
        adminTargetUser: action.adminTargetUser,
      };

    default:
      return state;
  }
};
